/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Grid, Cell } from '../../../../components/Grid';

import ProfileAvatar from '../../../../components/ProfileAvatar';

interface Props {
  profile: any;
  isMainProfile: boolean;
  isSelf: boolean;
  allowEdit: boolean;
}

const ProfileOwnerRow = (props: Props) => {
  const { profile, isMainProfile, isSelf, allowEdit } = props;
  return (
    <div>
      <Grid alignItems="center" spacing="small" style={{ opacity: allowEdit ? 1 : 0.65 }}>
        <Cell>
          <ProfileAvatar profile={profile} size={56} fontSize={15} />
        </Cell>
        <div style={{ marginLeft: 12 }}>
          <div className="font-body">
            {
              isMainProfile ? (
                <FormattedMessage id="profileAccess.self.label">
                  {(me) => <span>{`${profile.formalName()} (${me})`}</span>}
                </FormattedMessage>
              ) : profile.formalName()
            }
          </div>

          <div className="access font-footnote font-color-gsDark">
            {
              isSelf && (
                <>
                <FormattedMessage id="access.userList.self.label" />{' – '}
                </>
              )
            }
            <FormattedMessage id="access.userList.fullAccess.label" />
          </div>
        </div>
      </Grid>
    </div>
  );
};

export default ProfileOwnerRow;
